export const toTitleCase = (text: string) => {
	const acronyms = new Set(['OTC']);

	return text
		.split(' ')
		.map(word =>
			word
				.split('-')
				.map(part =>
					acronyms.has(part.toUpperCase())
						? part.toUpperCase()
						: part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
				)
				.join('-')
		)
		.join(' ');
};
